/**
 * Utility functions for formatting the place object
 *
 * Copyright (c) 2023 Propellant Software Corp
 * Author: Kelvin Nguyen
 */

export const getPlaceTitle = (place, orderNum) => {
  const { name } = place
  const orderNumIndicator = (orderNum > 0) ? `${orderNum}.` : ''

  return `${orderNumIndicator} ${name}`.trim()
}

export const getPlaceLocation = (place) => {
  const { name, location } = place
  let locationText = location?.displayText || ''

  // LocationText can have the entire display name with a comma. This helps filter it out
  if (locationText) {
    locationText = locationText.replace(name, '')

    if (locationText.startsWith(', ')) {
      locationText = locationText.replace(', ', '')
    }
  }

  return locationText.trim()
}
